// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xAddressValidationHandlerType } from "@eisinc/App/Handlers/XNG/AddressValidationSuggestion";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xAddressValidationStateType = Readonly<{
    addressValidationState: boolean;
    
}>;

export const initilAddressValidationtState: xAddressValidationStateType = {
    addressValidationState: false,
};

const reducer = {
    "xAddressValidation/update": (draft: Draft<xAddressValidationStateType>, action: { data: xAddressValidationHandlerType }) => {
        draft.addressValidationState = action.data.addressValidationState
    },
};

const xAddressValidation = createTypedReducerWithImmer(initilAddressValidationtState, reducer);

(reducers as any).xAddressValidation = xAddressValidation;

export type xAddressValidationState = {
    xAddressValidation: xAddressValidationStateType;
} & ApplicationState;

type xAddressValidationReducers = {
    [key: string]: typeof xAddressValidation;
};

export type xAddressValidationActions = Parameters<xAddressValidationReducers[keyof xAddressValidationReducers]>[1] | AnyAction;
